import React from 'react';
import { observer } from 'owa-mobx-react';
import { makeStyles, tokens, mergeClasses } from '@fluentui/react-components';
import { isCapabilityEnabled } from 'owa-capabilities';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';

interface CopilotCommandCenterWrapperProps {
    children: React.ReactNode;
    wrapperStyles?: string;
}

/**
 * Wrapper `div` element that applies different styles when the current theme needing the
 * bleedthrough capability.
 */
export const CopilotCommandCenterWrapper: React.FunctionComponent<CopilotCommandCenterWrapperProps> =
    observer(
        ({ children, wrapperStyles: wrapperStylesFromHost }: CopilotCommandCenterWrapperProps) => {
            const { wrapper, wrapperBleedThrough } = useStyles();

            const isBleedThroughEnabled = isCapabilityEnabled(bleedThroughCapability);

            const wrapperStyles = isBleedThroughEnabled
                ? mergeClasses(wrapper, wrapperBleedThrough)
                : wrapper;

            return (
                <div className={mergeClasses(wrapperStyles, wrapperStylesFromHost)}>{children}</div>
            );
        },
        'CopilotCommandCenterWrapper'
    );

const useStyles = makeStyles({
    wrapper: {
        display: 'flex',
        // The `background`, `borderRadius`, and `boxShadow` definitions below match
        // the Fluent UI v9 variation of `RibbonBottomBar`
        background: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusXLarge,
        boxShadow: tokens.shadow4,

        // Necessary to avoid having the bottom of the `boxShadow` be cutoff
        zIndex: '1',

        margin: '0 0 0 12px',
        padding: '4px',
    },
    wrapperBleedThrough: {
        marginLeft: '6px',
    },
});
